import { Navigate } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { EngagementRedirectToRouteDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { seeInsights } from 'modules/engagement/lib/authorization'
import { hasEnpsModule } from 'modules/engagement/lib/hasEnpsModule'
import { hasSurveysModule } from 'modules/engagement/lib/hasSurveysModule'

const RedirectToRoutePage = () => {
  const { data, loading } = useQuery(EngagementRedirectToRouteDocument)
  const { moduleAvailabilities, enpsInstalled, canManageSurveys } = useEngagementContext()
  const { employee: currentEmployee } = useCurrentSession()

  const accessSurveysSeeForms = data?.apiCore._policies.accessSurveysSeeForms.can ?? false
  const accessEnpsSeeForms = data?.apiCore._policies.accessEnpsSeeForms.can ?? false
  const manageSurveys = data?.surveys._policies.v2ManageSurveys.can ?? false
  const canSeeMeetings = data?.meetings._policies.seeMeetings.can ?? false

  const canSeeSurveys =
    hasSurveysModule(moduleAvailabilities) && (manageSurveys || accessSurveysSeeForms)
  const canSeeEnps = hasEnpsModule(moduleAvailabilities) && accessEnpsSeeForms
  const canSeeInsights = seeInsights(moduleAvailabilities, currentEmployee, canManageSurveys)
  const { navigation } = useNavigation()

  if (loading) {
    return
  }

  const buildUrl = () => {
    if (canSeeMeetings) {
      return navigation.engagement.one_on_ones.fullPath()
    }

    if (data?.engagement._policies.seePulseDashboard.can) {
      return navigation.engagement.pulse.fullPath()
    }

    if (canSeeSurveys) {
      return navigation.engagement.surveys.fullPath()
    }

    if (canSeeEnps && enpsInstalled) {
      return navigation.engagement.enps.fullPath()
    }

    if (canSeeInsights) {
      return navigation.engagement.insights.fullPath()
    }

    return navigation.dashboard.fullPath()
  }

  return <Navigate to={buildUrl()} />
}

export default RedirectToRoutePage
